import ProjKpiEditorForm from '@/views/kpi/kpi-build/proj-kpi/proj-kpi-editor-form.vue';
export const useProjKpiEditorModal = () => {
  const {
    openEditor
  } = useComponentModal();
  const showProjKpiEditorModal = async (title, {
    id = ''
  } = {}) => {
    return openEditor(title, ProjKpiEditorForm, {
      id
    }, {
      width: '70%',
      showMaximize: false,
      showMinimize: false
    });
  };
  return {
    showProjKpiEditorModal
  };
};